/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';

    /**
     * Factory callback type
     */
    declare type SidebarPrimaryDirectiveFactoryCb = ($rootScope: ng.IRootScopeService,
                                                     $window: ng.IWindowService,
                                                     $timeout: ng.ITimeoutService,
                                                     $document: ng.IDocumentService) => SidebarPrimaryDirective;

    /**
     * Custom scope
     */
    export interface ISidebarPrimaryDirectiveScope extends ng.IScope {
        submenuToggle: ($event: IExtendedEvent) => void;
    }

    interface IExtendedEvent extends ng.IAngularEvent {
        currentTarget: Object;
    }

    export class SidebarPrimaryDirective implements ng.IDirective {
        public static $name: string = 'sidebarPrimary';

        public link: ($scope: ng.IScope, $element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'A';
        public transclude: boolean = false;
        public template: string = '';

        /**
         * Factory for the directive
         */
        public static Factory(): SidebarPrimaryDirectiveFactoryCb {
            let directive: SidebarPrimaryDirectiveFactoryCb = ($rootScope: IFlexRootScope,
                                                               $window: ng.IWindowService,
                                                               $timeout: ng.ITimeoutService,
                                                               $document: ng.IDocumentService) => {
                return new SidebarPrimaryDirective($rootScope, $window, $timeout, $document);
            };
            directive.$inject = ['$rootScope', '$window', '$timeout', '$document'];
            return directive;
        }

        /**
         * Constructor
         */
        constructor($rootScope: IFlexRootScope,
                    $window: ng.IWindowService,
                    $timeout: ng.ITimeoutService,
                    $document: ng.IDocumentService) {

            SidebarPrimaryDirective.prototype.link = ($scope: ISidebarPrimaryDirectiveScope, $element: JQuery, attrs: ng.IAttributes) => {
                $scope.submenuToggle = ($event: IExtendedEvent, fromMiniSidebar?: boolean): void => {
                    $event.preventDefault();
                    if (!fromMiniSidebar) {
                        let currentTarget: JQuery = $($event.currentTarget);
                        let sidebarMain: JQuery = $('#sidebar_main');
                        let slideToogle: string = currentTarget.next('ul').is(':visible') ? 'slideUp' : 'slideDown';
                        currentTarget.next('ul')
                            .velocity(slideToogle, {
                                duration: 400,
                                easing: [0.4, 0, 1, 1],
                                begin: () => {
                                    if (slideToogle === 'slideUp') {
                                        currentTarget.parent().removeClass('act_section');
                                    } else {
                                        currentTarget.closest('li').siblings('.submenu_trigger').each(() => {
                                            $(this).children('ul').velocity('slideUp', {
                                                duration: 500,
                                                easing: Common.AltairUtils.easingSwiftOut,
                                                begin: () => {
                                                    currentTarget.parent().removeClass('act_section');
                                                },
                                            });
                                        });
                                        currentTarget.parent().addClass('act_section');
                                    }
                                },
                                complete: () => {
                                    if (slideToogle !== 'slideUp') {
                                        let scrollContainer: JQuery = sidebarMain.find(".scroll-content").length ?
                                            sidebarMain.find(".scroll-content") : sidebarMain.find(".scrollbar-inner");

                                        currentTarget.closest('.act_section').velocity("scroll", {
                                            duration: 500,
                                            easing: Common.AltairUtils.easingSwiftOut,
                                            container: scrollContainer,
                                        });
                                    }
                                },
                            });
                    }
                };

                $document.ready(() => {
                    $timeout(() => {
                        const menuEntry: ng.IAugmentedJQuery = angular.element('.current_section.submenu_trigger > a');
                        if (menuEntry.length > 0) {
                            menuEntry.triggerHandler('click');
                        }
                    }, 1000);
                });
            };
        }
    }
}
